// frontend/admin-portal/src/hooks/useStoreIdentity.js
import { useSettings } from '../contexts/SettingsContext';

/**
 * Pull the store identity out of Settings so any component can display
 * it consistently (invoices, offers, orders, PDFs, etc.).
 */
export function useStoreIdentity() {
    const { get } = useSettings();

    return {
        name: get('store.name', 'FiberHome'),
        legalName: get('store.legalName', ''),
        taxId: get('store.taxId', ''),
        logo: get('store.logo', ''),
        address: get('store.address', ''),
        phone: get('store.phone', ''),
        email: get('store.email', ''),
        website: get('store.website', ''),
        currency: get('finance.baseCurrency', 'USD'),
        currencySymbol: get('finance.currencySymbol', '$'),
    };
}